/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ITeachingBubbleStyles } from '@fluentui/react/lib/TeachingBubble';

import { FontSizes } from '../../../styles/teams';

export const getTeachingBubbleStyles = (): Partial<ITeachingBubbleStyles> => {
    return {
        header: { marginBottom: '0.75rem !important' },
        headline: { fontSize: FontSizes.size18 },
        subText: { fontSize: FontSizes.size12 },
        bodyContent: { padding: '0.75rem 1rem', borderRadius: '4px' },
        footer: {
            flexDirection: 'column',
            width: '100%',
            selectors: {
                '&>div:last-of-type': {
                    display: 'flex',
                    flexDirection: 'column-reverse',
                    width: '100%',
                },
                button: {
                    width: '100%',
                    borderRadius: '4px',
                    marginLeft: '0rem !important',
                },
            },
        },
        secondaryButton: {
            marginTop: '0.5rem',
        },
        closeButton: {
            marginTop: '0.5rem',
            marginRight: '0.5rem',
        },
    };
};
